import React from "react";
import { Helmet } from "react-helmet";

const assetUrl = (assetPath) => (
  assetPath && !assetPath.startsWith("/") && !assetPath.startsWith("http")
    ? `/${assetPath}`
    : assetPath
);

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      {props.isStandalone && (
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>Client Testimonials - ICL Software Solutions</title>

        <link rel="canonical" href="https://eximon.com/testimonials/" />

        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Read testimonials from ICL Software clients and discover how our enterprise solutions have helped businesses achieve success in maritime, logistics, and export-import operations."
        />

        {/* Open Graph */}
        <meta property="og:title" content="Client Testimonials - ICL Software Solutions" />
        <meta property="og:type" content="article" />
        <meta property="og:url" content="https://eximon.com/testimonials/" />
        <meta
          property="og:description"
          content="See what clients say about ICL Software. Explore success stories and feedback from businesses using our enterprise solutions."
        />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Client Testimonials - ICL Software Solutions" />
        <meta
          name="twitter:description"
          content="Read testimonials and success stories from ICL Software clients who have benefited from our enterprise solutions."
        />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
      </Helmet>
)}
      <div className="container">
        <div className="section-title text-center">
          <h1>What our clients say</h1>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-4">
                <div className="testimonial">
                  <div className="testimonial-image">
                    {" "}
                    <img src={assetUrl(d.img)} alt={d.name} />{" "}
                  </div>
                  <div className="testimonial-content">
                    <p>"{d.text}"</p>
                    <div className="testimonial-meta"> - {d.name} </div>
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
